import { registerComponent } from '@gig/magic-common';
import PhoneNumberComponent from './phone-number.vue.js';
export { default as PhoneNumberComponent } from './phone-number.vue.js';

var PhoneNumber = registerComponent(PhoneNumberComponent);

export { PhoneNumber };
